const HOURS_PER_WEEK = 40;
const HOURS_PER_DAY = 8;
const MINUTES_PER_HOUR = 60;
const ROUND_TO_MIN = 15;

export function formatFromMinutes(value: number): string {
    const totalHours = Math.floor(value / MINUTES_PER_HOUR);
    const minutes = value % MINUTES_PER_HOUR;

    const weeks = Math.floor(totalHours / HOURS_PER_WEEK);
    const days = Math.floor((totalHours % HOURS_PER_WEEK) / HOURS_PER_DAY);
    const hours = totalHours % HOURS_PER_DAY;

    const parts: string[] = [];
    if (weeks) parts.push(`${weeks}w`);
    if (days) parts.push(`${days}d`);
    if (hours) parts.push(`${hours}h`);
    if (minutes) parts.push(`${minutes}m`);
    if (parts.length === 0) parts.push("0m");

    return parts.join(" ");
}

export function formatToMinutes(value: string) {
    let parts = value.split(" ");
    let hours = 0
    parts.forEach(part => {
        const match = part.match(/^(\d+)([a-zA-Z]+)$/)
        if (!match) {
            throw new Error(`${part} is not a valid value`)
        }
        const [_, num, unit] = match
        let parsedNum = parseInt(num)
        switch (unit.toLowerCase()) {
            case "w":
                hours += parsedNum * HOURS_PER_WEEK
                break
            case "d":
                hours += parsedNum * HOURS_PER_DAY
                break
            case "h":
                hours += parsedNum
                break
            case "m":
                hours += parsedNum / MINUTES_PER_HOUR
                break
        }
    })
    return Math.ceil(hours * MINUTES_PER_HOUR / ROUND_TO_MIN) * ROUND_TO_MIN
}

export function minToHours(totalMin: number) {
    const hours = Math.floor(totalMin / MINUTES_PER_HOUR)
    const min = totalMin % MINUTES_PER_HOUR;
    return hours.toString().padStart(2, '0') + ':' + min.toString().padStart(2, '0');
}